// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__34J1j","label":"SetPasswdForm_label__2UI0D"};